import { getAction } from '@/api/action'

export default {
  async appBaseSelect (params) {
    return getAction('/api/app/base/app/base/info/select', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/user.js